import React, { createContext, useContext, useState, ReactNode } from 'react';

interface ProductAlertContextType {
  showProductAlert: boolean;
  productId: string | null;
  openProductAlert: (productId: string) => void;
  closeProductAlert: () => void;
}

const ProductAlertContext = createContext<ProductAlertContextType | undefined>(undefined);

export const ProductAlertProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [showProductAlert, setShowProductAlert] = useState(false);
  const [productId, setProductId] = useState<string | null>(null);

  const openProductAlert = (id: string) => {
    setProductId(id);
    setShowProductAlert(true);
    sessionStorage.setItem('lastCreatedProductId', id);
  };

  const closeProductAlert = () => {
    setShowProductAlert(false);
  };

  return (
    <ProductAlertContext.Provider 
      value={{ 
        showProductAlert, 
        productId, 
        openProductAlert, 
        closeProductAlert 
      }}
    >
      {children}
    </ProductAlertContext.Provider>
  );
};

export const useProductAlert = () => {
  const context = useContext(ProductAlertContext);
  if (context === undefined) {
    throw new Error('useProductAlert must be used within a ProductAlertProvider');
  }
  return context;
};
